import useSentry from 'hooks/useSentry';

export const SentryMonitor = () => {
    // Once the top-level components are moved to function components, they can use the hook directly.
    // In the meantime, this thin wrapper component lets them use the functionality as Class components.
    useSentry();
    return null;
};
